





































































































































































































































































import {
  DrivewealthAccountSummary,
  FetchState,
  GenericBarChartDataPoint,
  GenericGraphPoint,
  GenericChartValueType,
  InstrumentDetail,
  InstrumentPerformanceData,
  InstrumentPerformanceGraphTimePeriod,
  InstrumentStatus,
  HistoricalPerformanceFrequency,
  InstrumentFundamentals
} from "@/shared/types";
import { Component, Prop, Vue } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import GenericLineChart from "@/shared/components/charts/GenericLineChart.vue";
import GenericBarChart from "@/shared/components/charts/GenericBarChart.vue";
import { formatCurrency } from "@/shared/currency";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInstrumentPerformanceDataStore } from "@/shared/store/instrumentPerformanceData";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import _ from "lodash";
import * as SharedRoutes from "@/shared/route-names";

interface PriceGraphSelectOption {
  text: string;
  value: InstrumentPerformanceGraphTimePeriod;
}

interface HistoricalFrequencySelectOption {
  text: string;
  value: HistoricalPerformanceFrequency;
}

@Component({
  computed: {
    SharedRoutes () {
      return SharedRoutes;
    },
    FetchState () {
      return FetchState;
    },
    GenericChartValueType () {
      return GenericChartValueType;
    },
    HistoricalPerformanceFrequency () {
      return HistoricalPerformanceFrequency;
    }
  },
  components: {
    GenericLoadingSpinner,
    GenericLineChart,
    DrivewealthNavigation,
    AccountTypeSubheader,
    GenericBarChart
  }
})
export default class InstrumentPerformanceView extends Vue {
  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop() symbol: string;
  @Prop() accountId: number;

  instrumentPerformanceDataStore = useInstrumentPerformanceDataStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  userStore = useUserStore();

  formatCurrency = formatCurrency;
  RouteNames = RouteNames;

  selectedGraphTimePeriod = InstrumentPerformanceGraphTimePeriod.Weeks1;
  selectedHistoricalPerformanceFrequency = HistoricalPerformanceFrequency.Quarterly;

  created (): void {
    this.instrumentPerformanceDataStore.getInstrumentPerformanceData({
      username: this.username, partnerId: this.partnerId, stockSymbol: this.symbol});
    this.instrumentPerformanceDataStore.getInstrumentPerformanceGraphData({
      username: this.username, partnerId: this.partnerId,
      stockSymbol: this.symbol, timePeriod: this.selectedGraphTimePeriod});
    this.instrumentPerformanceDataStore.getInstrumentFundamentals({
      username: this.username, partnerId: this.partnerId, stockSymbol: this.symbol});
    this.drivewealthStore.getAccountSummaryV2({
      username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
    });
    this.drivewealthStore.loadInstrumentData(this.symbol, this.accountId,
        { username: this.username, partnerId: this.partnerId });
  }

  get historicalPerformanceFrequencyOptions (): HistoricalFrequencySelectOption[] {
    return [
      {
        text: "Quarterly",
        value: HistoricalPerformanceFrequency.Quarterly,
      },
      {
        text: "Yearly",
        value: HistoricalPerformanceFrequency.Yearly,
      }
    ];
  }

  get graphTimePeriodOptions (): PriceGraphSelectOption[] {
    return [
      {
        text: "1 D",
        value: InstrumentPerformanceGraphTimePeriod.Days1
      },
      {
        text: "1 W",
        value: InstrumentPerformanceGraphTimePeriod.Weeks1
      },
      {
        text: "1 M",
        value: InstrumentPerformanceGraphTimePeriod.Months1
      },
      {
        text: "1 Y",
        value: InstrumentPerformanceGraphTimePeriod.Years1
      },
      {
        text: "2 Y",
        value: InstrumentPerformanceGraphTimePeriod.Years2
      },
      {
        text: "3 Y",
        value: InstrumentPerformanceGraphTimePeriod.Years3
      },
    ];
  }

  get graphDateFormat (): string {
    switch (this.selectedGraphTimePeriod) {
      case InstrumentPerformanceGraphTimePeriod.Days1:
        return "E H:mm a";
      case InstrumentPerformanceGraphTimePeriod.Weeks1:
        return "E MM/dd";
      case InstrumentPerformanceGraphTimePeriod.Months1:
        return "MM/dd/yyyy";
      case InstrumentPerformanceGraphTimePeriod.Years1:
      case InstrumentPerformanceGraphTimePeriod.Years2:
      case InstrumentPerformanceGraphTimePeriod.Years3:
        return "MMM yyyy";
      default:
        return "MM/dd/yyyy";
    }
  }

  openInstrumentUrl (): void {
    this.drivewealthStore.openInstrumentDetailFundResearchUrl({ stockSymbol: this.symbol, fallbackUrl: this.instrumentDetail.website });
  }

  get graphPointsLoaded (): boolean {
    return this.instrumentPerformanceDataStore.fundPerformanceGraphLoaded({
      stockSymbol: this.symbol, timePeriod: this.selectedGraphTimePeriod
    });
  }

  get graphPointsForSelectedTimePeriod (): GenericGraphPoint[] {
    if (!this.graphPointsLoaded) {
      return [];
    }

    return this.instrumentPerformanceDataStore.fundPerformanceGraphPoints({
      stockSymbol: this.symbol, timePeriod: this.selectedGraphTimePeriod
    });
  }

  get previousDayClosePrice (): number {
    return this.instrumentPerformanceDataStore.previousDayClosePrice(this.symbol);
  }

  get previousDayPercentageChange (): number {
    const percentageChange = (100 *
        (this.instrumentDetail.currentPrice - this.previousDayClosePrice) /
        ((this.instrumentDetail.currentPrice + this.previousDayClosePrice) / 2));
    return _.isNaN(percentageChange) ? 0 : percentageChange;
  }

  get trailingPerformancesBarChartData (): GenericBarChartDataPoint[] {
    return this.instrumentPerformanceDataStore.trailingPerformancesBarChartData(this.symbol);
  }

  get historicalPerformancesBarChartData (): GenericBarChartDataPoint[] {
    return this.instrumentPerformanceDataStore
        .historicalPerformancesBarChartData(this.symbol, this.selectedHistoricalPerformanceFrequency);
  }

  updateGraphTimePeriod (timePeriod: InstrumentPerformanceGraphTimePeriod): void {
    this.selectedGraphTimePeriod = timePeriod;
    this.instrumentPerformanceDataStore.getInstrumentPerformanceGraphData({
      username: this.username, partnerId: this.partnerId,
      stockSymbol: this.symbol, timePeriod: this.selectedGraphTimePeriod});
  }

  updateHistoricalPerformanceFrequency (frequency: HistoricalPerformanceFrequency): void {
    this.selectedHistoricalPerformanceFrequency = frequency;
  }

  get isLoaded (): boolean {
    return this.instrumentPerformanceDataStore.instrumentPerformanceLoaded(this.symbol) &&
        this.instrumentPerformanceDataStore.instrumentFundamentalsLoaded(this.symbol);
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get hasAccount (): boolean {
    return this.accountId !== undefined;
  }

  routeParams (symbol: string): { symbol: string, accountId?: number, partnerId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId, partnerId: this.partnerId };
    }

    return { symbol, partnerId: this.partnerId };
  }

  isPositiveNumber (value: number): boolean {
    return value >= 0;
  }

  formatDisplayFiniteValue (value: number): string {
    if (_.isFinite(value)) {
      return `${value.toFixed(2)}%`;
    }

    return "N/A";
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.instrumentDetailBySymbol(this.symbol);
  }

  get canBuyThisInstrument (): boolean {
    return this.instrumentDetail && this.instrumentDetail.status === InstrumentStatus.Active;
  }

  get canSellThisInstrument (): boolean {
    if (!this.accountSummaryV2) {
      return false;
    }

    const holding = _.find(this.accountSummaryV2.holdings, x => x.stockSymbol === this.symbol);
    return !!holding;
  }

  get isLoading (): boolean {
    return this.instrumentPerformanceDataStore.instrumentPerformanceLoading(this.symbol);
  }

  get instrumentPerformanceData (): InstrumentPerformanceData {
    return this.instrumentPerformanceDataStore.instrumentPerformanceData(this.symbol);
  }

  get instrumentFundamentals (): InstrumentFundamentals {
    return this.instrumentPerformanceDataStore.instrumentFundamentalsData(this.symbol);
  }
}
